import { ApiClientFactory } from "common/middleware/api.client-factory";
import { Logger } from "common/middleware/logger";

export const markAllNotificationsAsRead = async () => {
  Logger.debug("Marking all notifications as read");
  const client = await ApiClientFactory.getUserNotificationsClient();
  await client.markAllAsRead();
};
